import { AMP_CLASS } from 'enums/amp'

export default {
  computed: {
    $_ampClass() {
      return { [AMP_CLASS]: this.$helper.isAmpPage(this.$route.name) }
    }
  }
}
